// extracted by mini-css-extract-plugin
export default {"container":"resolution-scaling-warning-header_container__2fMiU"};